import {
    useBusinessBuyer,
    useCreditAppSelector,
    useCustomerSelector,
    useDeepLinkUrlSelector
} from '@makemydeal/dr-sales-checkin-store';
import { buildCustomerDetailsTitle, useOpenTakeover, useShareCreditAppLink } from '@makemydeal/dr-sales-checkin-components';
import { DeepLinks, FEATURES } from '@makemydeal/dr-sales-checkin-types';
import type { CustomerDetails } from '@makemydeal/dr-sales-checkin-types';

export const useCustomerDetails = (): CustomerDetails => {
    const { checkedInCustomer, coBuyer } = useCustomerSelector();
    const { isBusinessBuyer, legalName } = useBusinessBuyer();
    const { isCreditAppCompleted } = useCreditAppSelector();
    const creditAppLink = useDeepLinkUrlSelector(DeepLinks.CreditApp);
    const openTakeover = useOpenTakeover();
    const { shareCreditAppLink } = useShareCreditAppLink();

    const buyerFirstName = checkedInCustomer?.firstName || '';
    const buyerFullName = [checkedInCustomer?.firstName, checkedInCustomer?.lastName].filter(Boolean).join(' ');

    return {
        title: buildCustomerDetailsTitle({
            buyerFirstName,
            legalName,
            isBusinessBuyer,
            coBuyerFirstName: coBuyer?.firstName || undefined
        }),
        buyerFirstName,
        buyerFullName,
        buyerEmail: checkedInCustomer?.primaryEmail || '',
        creditAppLink,
        isCreditAppSubmitted: isCreditAppCompleted,
        onEdit: () => openTakeover(FEATURES.CUSTOMER_DETAILS),
        onSendLink: shareCreditAppLink
    };
};
